import { call, put, select } from 'redux-saga/effects';
import serviceLocator, { SSAP_SVC } from '@APIs/common/service-locator';
import {
    fetchEnrollmentsFailure,
    fetchEnrollmentsSuccess,
    fetchEnrollmentsProgress,
    setBulkEnrollments
} from '@actions/ssap/ssapActionCreators';

import { getApplicantGuids, getApplicationId } from '@reducers/appReducer';

export function* enrollmentsSaga() {
    try {
        yield put(fetchEnrollmentsProgress(false));
        const ssapApplicationId = yield select(getApplicationId);
        const memberGuids = yield select(getApplicantGuids);
        const ssapService = yield call(serviceLocator, SSAP_SVC);
        const enrollments = yield call(
            [ ssapService, ssapService.getEnrollments ],
            { ssapApplicationId, memberGuids }
        );

        if(enrollments) {
            yield put(setBulkEnrollments(enrollments));
            yield put(fetchEnrollmentsSuccess());
        } else {
            yield put(fetchEnrollmentsFailure());
        }
    } catch (e) {
        yield put(fetchEnrollmentsFailure());
    } finally {
        yield put(fetchEnrollmentsProgress(true));
    }
}